import createApiService from "@lib/create-api-service";
import { API_ROUTES, CONFIG } from "@utils/constants";

import validateLockersResponse, { TLockersResponse } from "../models/lockers";
import type { TLockerEntry } from "../types";
import mapLockersResponse from "../utils/mapLockersResponse";

const getLockers = createApiService<TLockersResponse>({ method: "GET", url: API_ROUTES.LOCKERS });

const loadLockers = async (
  countryCode: string,
  searchQuery: string,

  errCallback?: (message?: string) => void
): Promise<TLockerEntry[]> => {
  try {
    const response = await getLockers({
      params: {
        countryCode,
        search: searchQuery,

        limit: CONFIG.LOCKERS_SUGGEST_LIMIT.toString(),
        order: CONFIG.LOCKERS_SUGGEST_ORDER,
      },
    });
    if (!response.isSuccess) {
      errCallback?.(response.errorMessage);
      return [];
    }

    const validResponse = validateLockersResponse(response.data ?? []);
    return mapLockersResponse(validResponse);
  } catch (err) {
    console.error(err);
    errCallback?.();
    return [];
  }
};
export default loadLockers;
